import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    isUnarchiving?: boolean;
};

const UnarchiveManifestModal = ({ open, isUnarchiving, onConfirm, onClose }: Props) => {
    return (
        <ConfirmationModal
            width={400}
            open={open}
            icon={<ContainerOutlined />}
            title="Unacrhive Manifest?"
            confirmButtonText="Unarchive"
            confirmationButtonLoading={isUnarchiving}
            onCancel={onClose}
            onConfirm={onConfirm}
            content={<Typography.Text>The manifest will be unarchived and become active.</Typography.Text>}
        />
    );
};

export default UnarchiveManifestModal;
